export const getLeasesApi = (params, query) => {
  const { asset_type, asset_id, ...rest } = query || {};
  const urlParams = new URLSearchParams();

  Object.entries(rest).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    urlParams.set(key, value);
  });

  let queryString = urlParams.toString();
  if (asset_id?.length) {
    const assetFilter = Array.isArray(asset_id) ? asset_id : asset_id.toString().split(',').filter(Boolean);
    const assetParam = `asset_id=[${assetFilter.join(',')}]`;
    queryString = queryString ? `${queryString}&${assetParam}` : assetParam;
  }
  if (asset_type?.length) {
    const assetTypes = `asset_type=${asset_type.toString().split(',')}`;
    queryString = queryString ? `${queryString}&${assetTypes}` : assetTypes;
  }

  return `/leases${queryString ? `?${queryString}` : ''}`
}
export const getRoleListApi = (params, query) => {
  return `/party_roles`
}
export const updateLeaseStatusApi = (params) => {
  return `${params?.asset_type}/${params?.asset_slug}/lease-status/${params?.leaseSlug}/?lessor_id=${params?.lessor_id}`
}
export const addLeaseApi = (params, payload) => {
  return `${params?.asset_type}/${params?.asset_slug}/lease`
}
export const editLeaseApi = (params, payload) => {
  return `${params?.asset_type}/${params?.asset_slug}/lease/${params?.slug}/`
}
export const deleteLeaseApi = () => {
  return `/leases`
}

export const bulkExportLeaseApi = () => {
  return `/lease-summary/templates/bulk-export`
}

export const leasefileUploadPostApi = (supplement_slug) => {
    return `/get-pre-signed-url/lease/${supplement_slug}`;
};

export const leaseAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/lease/${attachments_slug}`
}

export const getAssetListApi = (query, excludeOnWing = false) => {
  const queryString = new URLSearchParams({ ...query, ...(excludeOnWing ? {} : { include_on_wing: true }), }).toString();
  return `/api/dropdown/asset/${queryString ? `?${queryString}` : ""}`
}


